import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Bars3Icon, XMarkIcon, BellIcon } from '@heroicons/react/24/outline';
import { useLocation } from 'react-router-dom';
import { useRoutePath } from '../../utils/getRoutePath';
  
const Navbar = ({ onSidebarToggle, isSidebarOpen }) => {
  const location = useLocation();

  const { user, logout } = useAuth();
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const profileMenuRef = useRef(null);
  const getRoutePath = useRoutePath();
   
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
  };

  return (
    <nav className="bg-[#009efb] shadow-sm fixed w-full z-50">
      <div className="max-w-10xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            {/* Mobile menu button */}
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-[#0089db] focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white lg:hidden"
              onClick={onSidebarToggle}
            >
              <span className="sr-only">Open main menu</span>
              {isSidebarOpen ? (
                <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
              ) : (
                <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
              )}
            </button>

            {/* Logo */}
            <div className="flex-shrink-0 flex items-center">
              <Link to="/dashboard" className="text-xl font-bold text-white">
                {isMobile ? 'SA' : 'ServiceAzip'}
              </Link>
            </div>
          </div>

          <div className="flex items-center">
            {/* Notifications */}
            <button
              type="button"
              className="p-2 rounded-full text-white hover:text-white hover:bg-[#0089db] focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            >
              <span className="sr-only">View notifications</span>
              <BellIcon className="h-6 w-6" aria-hidden="true" />
            </button>

            {/* Profile dropdown */}
            <div className="ml-3 relative" ref={profileMenuRef}>
              <div>
                <button
                  type="button"
                  className="flex items-center max-w-xs rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
                  onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                > 
                  <span className="sr-only">Open user menu</span>
                  <img
                    className="h-8 w-8 rounded-full bg-gray-100 object-cover"
                    src={user && typeof user === 'object' && user.image && typeof user.image === 'object' && typeof user.image.path === 'string' ? user.image.path : '/assets/images/default-avatar.png'}
                    alt={user && typeof user === 'object' ? String(user.name || 'User') : 'User'}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/assets/images/default-avatar.png';
                    }}
                  />
                </button>
              </div>

              {/* Profile dropdown menu */}
              {isProfileMenuOpen && (
                <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="px-4 py-2 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                    <p className="text-xs text-gray-500">{user?.email}</p>
                  </div>
                 {/* <Link
                    to="/profile"
                    className={`block px-4 py-2 text-sm ${
                      location.pathname === getRoutePath('/profile')
                        ? 'text-[#009efb]'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                    onClick={() => setIsProfileMenuOpen(false)}
                  >
                    Your Profile
                  </Link>*/}
                  <Link
                    to={getRoutePath('/change-password')}
                    className={`block px-4 py-2 text-sm ${
                      location.pathname === getRoutePath('/change-password')
                        ? 'text-[#009efb]'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                    onClick={() => setIsProfileMenuOpen(false)}
                  >
                    Change Password
                  </Link>
                  
                  <button
                    onClick={() => {
                      setIsProfileMenuOpen(false);
                      handleLogout();
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 